import { render, staticRenderFns } from "./content-board.vue?vue&type=template&id=bd91a4c0&"
import script from "./content-board.vue?vue&type=script&lang=js&"
export * from "./content-board.vue?vue&type=script&lang=js&"
import style0 from "./content-board.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-board.vue"
export default component.exports